import React from "react";
import {Trans} from "react-i18next";
import FormField from "./FormField";

class TextareaField extends FormField {
    render() {
        const {input, label, meta: {touched, error, warning, invalid}, disabled, autoFocus, placeholder} = this.props;

        return (
            <span className={`form-filed-container ${touched && invalid ? 'has-error' : ''}`}>
                {label && (<label>{label}</label>)}
                <textarea
                    {...input}
                    placeholder={placeholder}
                    className={this.getClassName()}
                    disabled={disabled}
                    autoFocus={autoFocus}
                />
                {touched && (
                    (error && <div className="text-danger scroll-to-error"><Trans>{error}</Trans></div>) ||
                    (warning && <div className="text-warning"><Trans>{warning}</Trans></div>)
                )}
            </span>
        )
    }
}

export default TextareaField;